// 由 scripts/extract-legacy-data.mjs 从第一版 HAR 机械提取。请勿手改坐标。
export const legacyAirportRows = [
  [
    "HKG",
    "香港",
    "Hong Kong",
    22.308,
    113.918,
    10
  ],
  [
    "SZX",
    "深圳",
    "Shenzhen",
    22.639,
    113.811,
    8
  ],
  [
    "CAN",
    "广州",
    "Guangzhou",
    23.392,
    113.299,
    9
  ],
  [
    "MFM",
    "澳门",
    "Macau",
    22.15,
    113.592,
    5
  ],
  [
    "XMN",
    "厦门",
    "Xiamen",
    24.544,
    118.128,
    6
  ],
  [
    "FOC",
    "福州",
    "Fuzhou",
    25.935,
    119.663,
    5
  ],
  [
    "TPE",
    "台北",
    "Taipei",
    25.078,
    121.233,
    8
  ],
  [
    "KHH",
    "高雄",
    "Kaohsiung",
    22.577,
    120.35,
    5
  ],
  [
    "PVG",
    "上海浦东",
    "Shanghai",
    31.144,
    121.808,
    10
  ],
  [
    "HGH",
    "杭州",
    "Hangzhou",
    30.23,
    120.434,
    7
  ],
  [
    "NKG",
    "南京",
    "Nanjing",
    31.742,
    118.862,
    6
  ],
  [
    "PEK",
    "北京首都",
    "Beijing Capital",
    40.08,
    116.603,
    10
  ],
  [
    "TSN",
    "天津",
    "Tianjin",
    39.124,
    117.346,
    6
  ],
  [
    "TAO",
    "青岛",
    "Qingdao",
    36.362,
    120.088,
    6
  ],
  [
    "DLC",
    "大连",
    "Dalian",
    38.966,
    121.539,
    5
  ],
  [
    "SHE",
    "沈阳",
    "Shenyang",
    41.64,
    123.483,
    5
  ],
  [
    "CTU",
    "成都",
    "Chengdu",
    30.579,
    103.947,
    8
  ],
  [
    "CKG",
    "重庆",
    "Chongqing",
    29.719,
    106.642,
    8
  ],
  [
    "XIY",
    "西安",
    "Xi'an",
    34.447,
    108.752,
    6
  ],
  [
    "WUH",
    "武汉",
    "Wuhan",
    30.784,
    114.208,
    7
  ],
  [
    "CSX",
    "长沙",
    "Changsha",
    28.189,
    113.22,
    6
  ],
  [
    "NNG",
    "南宁",
    "Nanning",
    22.608,
    108.172,
    4
  ],
  [
    "KMG",
    "昆明",
    "Kunming",
    24.992,
    102.744,
    6
  ],
  [
    "HAK",
    "海口",
    "Haikou",
    19.935,
    110.459,
    5
  ],
  [
    "SYX",
    "三亚",
    "Sanya",
    18.303,
    109.412,
    4
  ],
  [
    "ICN",
    "首尔",
    "Seoul",
    37.46,
    126.441,
    9
  ],
  [
    "PUS",
    "釜山",
    "Busan",
    35.18,
    128.938,
    6
  ],
  [
    "CJU",
    "济州",
    "Jeju",
    33.511,
    126.493,
    5
  ],
  [
    "HND",
    "东京羽田",
    "Tokyo Haneda",
    35.549,
    139.78,
    10
  ],
  [
    "NRT",
    "东京成田",
    "Tokyo Narita",
    35.772,
    140.393,
    9
  ],
  [
    "KIX",
    "大阪",
    "Osaka",
    34.427,
    135.244,
    8
  ],
  [
    "NGO",
    "名古屋",
    "Nagoya",
    34.858,
    136.805,
    6
  ],
  [
    "FUK",
    "福冈",
    "Fukuoka",
    33.586,
    130.451,
    6
  ],
  [
    "CTS",
    "札幌",
    "Sapporo",
    42.775,
    141.692,
    5
  ],
  [
    "OKA",
    "冲绳",
    "Okinawa",
    26.196,
    127.646,
    4
  ],
  [
    "MNL",
    "马尼拉",
    "Manila",
    14.509,
    121.02,
    8
  ],
  [
    "CEB",
    "宿务",
    "Cebu",
    10.308,
    123.979,
    5
  ],
  [
    "SIN",
    "新加坡",
    "Singapore",
    1.364,
    103.992,
    10
  ],
  [
    "KUL",
    "吉隆坡",
    "Kuala Lumpur",
    2.746,
    101.71,
    8
  ],
  [
    "PEN",
    "槟城",
    "Penang",
    5.297,
    100.277,
    4
  ],
  [
    "BKI",
    "亚庇",
    "Kota Kinabalu",
    5.937,
    116.051,
    4
  ],
  [
    "BWN",
    "斯里巴加湾",
    "Bandar Seri Begawan",
    4.944,
    114.928,
    3
  ],
  [
    "BKK",
    "曼谷",
    "Bangkok",
    13.69,
    100.75,
    9
  ],
  [
    "CNX",
    "清迈",
    "Chiang Mai",
    18.767,
    98.963,
    5
  ],
  [
    "HKT",
    "普吉",
    "Phuket",
    8.113,
    98.317,
    6
  ],
  [
    "SGN",
    "胡志明市",
    "Ho Chi Minh City",
    10.819,
    106.652,
    8
  ],
  [
    "HAN",
    "河内",
    "Hanoi",
    21.214,
    105.804,
    7
  ],
  [
    "DAD",
    "岘港",
    "Da Nang",
    16.044,
    108.199,
    4
  ],
  [
    "PNH",
    "金边",
    "Phnom Penh",
    11.547,
    104.844,
    4
  ],
  [
    "REP",
    "暹粒",
    "Siem Reap",
    13.411,
    103.813,
    4
  ],
  [
    "VTE",
    "万象",
    "Vientiane",
    17.988,
    102.563,
    3
  ],
  [
    "RGN",
    "仰光",
    "Yangon",
    16.907,
    96.133,
    4
  ],
  [
    "CGK",
    "雅加达",
    "Jakarta",
    -6.126,
    106.656,
    9
  ],
  [
    "DPS",
    "巴厘岛",
    "Denpasar",
    -8.748,
    115.167,
    7
  ],
  [
    "SUB",
    "泗水",
    "Surabaya",
    -7.38,
    112.787,
    5
  ],
  [
    "DAC",
    "达卡",
    "Dhaka",
    23.843,
    90.398,
    7
  ],
  [
    "CMB",
    "科伦坡",
    "Colombo",
    7.181,
    79.884,
    5
  ],
  [
    "MLE",
    "马累",
    "Malé",
    4.192,
    73.529,
    5
  ],
  [
    "KTM",
    "加德满都",
    "Kathmandu",
    27.697,
    85.359,
    4
  ],
  [
    "DEL",
    "德里",
    "New Delhi",
    28.556,
    77.1,
    10
  ],
  [
    "BOM",
    "孟买",
    "Mumbai",
    19.09,
    72.866,
    9
  ],
  [
    "BLR",
    "班加罗尔",
    "Bengaluru",
    13.199,
    77.707,
    8
  ],
  [
    "MAA",
    "金奈",
    "Chennai",
    12.994,
    80.171,
    7
  ],
  [
    "HYD",
    "海得拉巴",
    "Hyderabad",
    17.24,
    78.429,
    7
  ],
  [
    "CCU",
    "加尔各答",
    "Kolkata",
    22.655,
    88.447,
    6
  ],
  [
    "DXB",
    "迪拜",
    "Dubai",
    25.253,
    55.366,
    10
  ],
  [
    "DOH",
    "多哈",
    "Doha",
    25.273,
    51.608,
    8
  ],
  [
    "AUH",
    "阿布扎比",
    "Abu Dhabi",
    24.433,
    54.651,
    6
  ],
  [
    "RUH",
    "利雅得",
    "Riyadh",
    24.958,
    46.699,
    7
  ],
  [
    "JED",
    "吉达",
    "Jeddah",
    21.67,
    39.153,
    7
  ],
  [
    "TLV",
    "特拉维夫",
    "Tel Aviv",
    32.011,
    34.887,
    6
  ],
  [
    "IST",
    "伊斯坦布尔",
    "Istanbul",
    41.275,
    28.752,
    9
  ],
  [
    "SVO",
    "莫斯科",
    "Moscow",
    55.973,
    37.415,
    8
  ],
  [
    "LHR",
    "伦敦",
    "London",
    51.47,
    -0.454,
    10
  ],
  [
    "MAN",
    "曼彻斯特",
    "Manchester",
    53.354,
    -2.275,
    6
  ],
  [
    "DUB",
    "都柏林",
    "Dublin",
    53.421,
    -6.27,
    6
  ],
  [
    "CDG",
    "巴黎",
    "Paris",
    49.01,
    2.548,
    9
  ],
  [
    "AMS",
    "阿姆斯特丹",
    "Amsterdam",
    52.311,
    4.768,
    8
  ],
  [
    "FRA",
    "法兰克福",
    "Frankfurt",
    50.038,
    8.562,
    9
  ],
  [
    "ZRH",
    "苏黎世",
    "Zurich",
    47.458,
    8.556,
    7
  ],
  [
    "MAD",
    "马德里",
    "Madrid",
    40.498,
    -3.568,
    7
  ],
  [
    "BCN",
    "巴塞罗那",
    "Barcelona",
    41.297,
    2.083,
    7
  ],
  [
    "FCO",
    "罗马",
    "Rome",
    41.8,
    12.239,
    7
  ],
  [
    "MXP",
    "米兰",
    "Milan",
    45.63,
    8.723,
    7
  ],
  [
    "VIE",
    "维也纳",
    "Vienna",
    48.11,
    16.57,
    6
  ],
  [
    "WAW",
    "华沙",
    "Warsaw",
    52.166,
    20.967,
    6
  ],
  [
    "PRG",
    "布拉格",
    "Prague",
    50.101,
    14.26,
    6
  ],
  [
    "ATH",
    "雅典",
    "Athens",
    37.936,
    23.945,
    6
  ],
  [
    "CPH",
    "哥本哈根",
    "Copenhagen",
    55.618,
    12.656,
    6
  ],
  [
    "OSL",
    "奥斯陆",
    "Oslo",
    60.194,
    11.1,
    5
  ],
  [
    "ARN",
    "斯德哥尔摩",
    "Stockholm",
    59.652,
    17.919,
    6
  ],
  [
    "HEL",
    "赫尔辛基",
    "Helsinki",
    60.317,
    24.963,
    6
  ],
  [
    "CAI",
    "开罗",
    "Cairo",
    30.122,
    31.406,
    7
  ],
  [
    "JNB",
    "约翰内斯堡",
    "Johannesburg",
    -26.137,
    28.241,
    7
  ],
  [
    "CPT",
    "开普敦",
    "Cape Town",
    -33.972,
    18.602,
    6
  ],
  [
    "NBO",
    "内罗毕",
    "Nairobi",
    -1.319,
    36.928,
    5
  ],
  [
    "ADD",
    "亚的斯亚贝巴",
    "Addis Ababa",
    8.978,
    38.799,
    6
  ],
  [
    "LOS",
    "拉各斯",
    "Lagos",
    6.577,
    3.321,
    6
  ],
  [
    "SYD",
    "悉尼",
    "Sydney",
    -33.94,
    151.175,
    9
  ],
  [
    "MEL",
    "墨尔本",
    "Melbourne",
    -37.669,
    144.841,
    8
  ],
  [
    "BNE",
    "布里斯班",
    "Brisbane",
    -27.384,
    153.118,
    7
  ],
  [
    "PER",
    "珀斯",
    "Perth",
    -31.94,
    115.967,
    6
  ],
  [
    "AKL",
    "奥克兰",
    "Auckland",
    -37.008,
    174.785,
    6
  ],
  [
    "NAN",
    "楠迪",
    "Nadi",
    -17.755,
    177.443,
    3
  ],
  [
    "PPT",
    "帕皮提",
    "Papeete",
    -17.557,
    -149.611,
    3
  ],
  [
    "GUM",
    "关岛",
    "Guam",
    13.483,
    144.796,
    3
  ],
  [
    "HNL",
    "檀香山",
    "Honolulu",
    21.325,
    -157.925,
    6
  ],
  [
    "ANC",
    "安克雷奇",
    "Anchorage",
    61.174,
    -149.996,
    4
  ],
  [
    "YVR",
    "温哥华",
    "Vancouver",
    49.197,
    -123.182,
    7
  ],
  [
    "YYZ",
    "多伦多",
    "Toronto",
    43.678,
    -79.625,
    8
  ],
  [
    "YUL",
    "蒙特利尔",
    "Montreal",
    45.471,
    -73.741,
    6
  ],
  [
    "SEA",
    "西雅图",
    "Seattle",
    47.45,
    -122.309,
    8
  ],
  [
    "SFO",
    "旧金山",
    "San Francisco",
    37.621,
    -122.379,
    9
  ],
  [
    "LAX",
    "洛杉矶",
    "Los Angeles",
    33.942,
    -118.409,
    10
  ],
  [
    "SAN",
    "圣迭戈",
    "San Diego",
    32.734,
    -117.193,
    6
  ],
  [
    "LAS",
    "拉斯维加斯",
    "Las Vegas",
    36.084,
    -115.154,
    7
  ],
  [
    "PHX",
    "菲尼克斯",
    "Phoenix",
    33.437,
    -112.008,
    7
  ],
  [
    "DFW",
    "达拉斯",
    "Dallas",
    32.9,
    -97.04,
    8
  ],
  [
    "IAH",
    "休斯顿",
    "Houston",
    29.99,
    -95.337,
    7
  ],
  [
    "ORD",
    "芝加哥",
    "Chicago",
    41.974,
    -87.907,
    9
  ],
  [
    "ATL",
    "亚特兰大",
    "Atlanta",
    33.641,
    -84.428,
    9
  ],
  [
    "MIA",
    "迈阿密",
    "Miami",
    25.796,
    -80.287,
    8
  ],
  [
    "BOS",
    "波士顿",
    "Boston",
    42.366,
    -71.01,
    7
  ],
  [
    "JFK",
    "纽约",
    "New York",
    40.641,
    -73.778,
    10
  ],
  [
    "EWR",
    "纽瓦克",
    "Newark",
    40.69,
    -74.175,
    8
  ],
  [
    "IAD",
    "华盛顿",
    "Washington DC",
    38.953,
    -77.457,
    7
  ],
  [
    "MEX",
    "墨西哥城",
    "Mexico City",
    19.436,
    -99.072,
    8
  ],
  [
    "GRU",
    "圣保罗",
    "São Paulo",
    -23.436,
    -46.473,
    8
  ],
  [
    "GIG",
    "里约热内卢",
    "Rio de Janeiro",
    -22.81,
    -43.251,
    7
  ],
  [
    "EZE",
    "布宜诺斯艾利斯",
    "Buenos Aires",
    -34.822,
    -58.536,
    6
  ],
  [
    "SCL",
    "圣地亚哥",
    "Santiago",
    -33.393,
    -70.786,
    6
  ],
  [
    "LIM",
    "利马",
    "Lima",
    -12.022,
    -77.114,
    6
  ],
  [
    "BOG",
    "波哥大",
    "Bogotá",
    4.702,
    -74.147,
    7
  ],
  [
    "SHA",
    "上海虹桥",
    "Shanghai Hongqiao",
    31.197,
    121.336,
    9
  ],
  [
    "PKX",
    "北京大兴",
    "Beijing Daxing",
    39.503,
    116.667,
    8
  ],
  [
    "CGO",
    "郑州",
    "Zhengzhou",
    34.52,
    113.84,
    6
  ],
  [
    "HFE",
    "合肥",
    "Hefei",
    31.761,
    117.001,
    5
  ],
  [
    "KHN",
    "南昌",
    "Nanchang",
    28.866,
    115.838,
    5
  ],
  [
    "KWE",
    "贵阳",
    "Guiyang",
    26.538,
    106.801,
    5
  ],
  [
    "TNA",
    "济南",
    "Jinan",
    36.854,
    116.849,
    5
  ],
  [
    "NGB",
    "宁波",
    "Ningbo",
    29.826,
    121.781,
    5
  ],
  [
    "WUX",
    "无锡",
    "Wuxi",
    31.478,
    120.115,
    4
  ],
  [
    "YNT",
    "烟台",
    "Yantai",
    37.636,
    120.931,
    4
  ],
  [
    "SJW",
    "石家庄",
    "Shijiazhuang",
    38.28,
    114.69,
    4
  ],
  [
    "TYN",
    "太原",
    "Taiyuan",
    37.788,
    112.621,
    5
  ],
  [
    "LHW",
    "兰州",
    "Lanzhou",
    36.515,
    103.62,
    4
  ],
  [
    "XNN",
    "西宁",
    "Xining",
    36.534,
    102.198,
    3
  ],
  [
    "HET",
    "呼和浩特",
    "Hohhot",
    40.601,
    111.827,
    4
  ],
  [
    "URU",
    "乌鲁木齐",
    "Urumqi",
    43.907,
    87.474,
    5
  ],
  [
    "LXA",
    "拉萨",
    "Lhasa",
    29.135,
    90.917,
    3
  ],
  [
    "KHG",
    "喀什",
    "Kashgar",
    39.541,
    75.948,
    3
  ],
  [
    "ZUH",
    "珠海",
    "Zhuhai",
    22.009,
    113.497,
    4
  ],
  [
    "SWA",
    "揭阳潮汕",
    "Jieyang Chaoshan",
    23.392,
    116.628,
    4
  ],
  [
    "LJG",
    "丽江",
    "Lijiang",
    26.555,
    100.274,
    3
  ],
  [
    "JHG",
    "西双版纳",
    "Xishuangbanna",
    22.406,
    100.785,
    3
  ],
  [
    "TFU",
    "成都天府",
    "Chengdu Tianfu",
    30.314,
    104.584,
    8
  ],
  [
    "YIE",
    "伊宁",
    "Yining",
    43.939,
    81.134,
    3
  ],
  [
    "HLD",
    "海拉尔",
    "Hailar",
    49.21,
    119.83,
    3
  ],
  [
    "EHU",
    "鄂尔多斯",
    "Ordos",
    39.521,
    110.0,
    3
  ],
  [
    "MIG",
    "绵阳",
    "Mianyang",
    31.44,
    104.362,
    3
  ],
  [
    "YBP",
    "宜宾",
    "Yibin",
    28.611,
    104.521,
    3
  ],
  [
    "LUM",
    "德宏芒市",
    "Mangshi",
    24.412,
    98.256,
    3
  ],
  [
    "YIW",
    "义乌",
    "Yiwu",
    29.35,
    119.977,
    3
  ]
] as const;
